import QRCode from 'qrcode.react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useContext, useState, useEffect } from 'react';
import { TwoFAContext } from '../contexts/TwoFAContext';
import { EgnValid } from '../utils/EgnValidator';

export const PairUpWithAuthenticators = ({ verfy2FA, data2FA, handle2FAChange, submitVerify2FA, submitChange2FAMethod, isInAdmin, username }) => {
    const { isEgnValid, checkUserEgnInDb, toggleCallFunction } = useContext(TwoFAContext);

    const [dataForCheckEgn, setDataForCheckEgn] = useState({
        username: username,
        egn: '',
        isInAdmin: isInAdmin
    })

    useEffect(() => {
        if (isEgnValid == false) {
            setError('Невалидни данни !')
        } else if (isEgnValid == true) {
            setError(null)
        }
    }, [toggleCallFunction, isEgnValid])

    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDataForCheckEgn({ ...dataForCheckEgn, [name]: value });
    };

    const onBlur = (e) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (!EgnValid(fieldValue)) {
            setError('Въведете валидно ЕГН !')
        } else {
            checkUserEgnInDb(dataForCheckEgn.username, dataForCheckEgn.egn, dataForCheckEgn.isInAdmin)
        }
    }

    return (
        <div className="children_data">
            {!isEgnValid
                ? isInAdmin
                    ? <div className='d-flex align-items-center flex-wrap flex-column'>
                        <div className="htext text-start text-success mb-3">За да продължите, въведете Вашето ЕГН</div>
                        <span className="p-float-label labels">
                            <InputText name='egn' id="egn" style={{ width: '100%' }} value={dataForCheckEgn.egn} onChange={handleChange} onBlur={onBlur} />
                            <label htmlFor="egn">ЕГН *</label>
                        </span>
                        {error && <label className="text-danger w-100 ">{error}</label>}
                        <Button
                            label="Продължи"
                            severity="success"
                            raised
                            className='btn-prim mt-4 w-100 w-100-mob'
                            disabled
                        />
                    </div>
                    : <div className='d-flex align-items-center flex-wrap flex-column'>
                        <div className="htext text-start text-success mb-3">За да продължите, въведете ЕГН на дете {verfy2FA.childName }</div>
                        <span className="p-float-label labels">
                            <InputText name='egn' id="egn" style={{ width: '100%' }} value={dataForCheckEgn.egn} onChange={handleChange} onBlur={onBlur} />
                            <label htmlFor="egn">ЕГН на дете {verfy2FA.childName}</label>
                        </span>
                        {error && <label className="text-danger w-30 ">{error}</label>}
                        <Button
                            label="Продължи"
                            severity="success"
                            raised
                            className='btn-prim mt-4 w-100-mob'
                            disabled
                        />
                        <p className='w-100 text-start mb-0 mt-4 text-center'>Можете да смените вида на двуфакторната автентикация от <button className="btn-link" onClick={submitChange2FAMethod}>ТУК</button></p>

                    </div>
                : <>
                    <div className="title_entr text-success">Конфигуриране на приложение за двуфакторна автентикация</div>
                    <div className="htext text-start">За да използвате приложение за двуфакторна автентикация, следвайте следните стъпки:</div>
                    <p className="text-md-start text-start">
                        1. Изтеглете приложение за двуфакторна автентикация като Microsoft Authenticator за
                        <a href='https://play.google.com/store/apps/details?id=com.azure.authenticator' target="_new"> Android</a> и
                        <a href='https://apps.apple.com/us/app/microsoft-authenticator/id983156458' target="_new"> iOS</a> или Google Authenticator за
                        <a href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2' target="_new"> Android</a> и
                        <a href='https://apps.apple.com/us/app/google-authenticator/id388497605' target="_new"> iOS</a>.<br></br>
                        <hr />

                        2. Сканирайте QR кода или въведете този ключ <b>{verfy2FA.secretKey}</b> във вашето приложение за двуфакторна автентикация. Интервалите и големината на буквите нямат значение.<br></br>
                        <QRCode value={verfy2FA.qrCodeUri} /><br></br>
                        <hr />

                        3. След като сканирате QR кода или въведете ключа по-горе, вашето приложение за двуфакторна автентикация ще ви предостави уникален код. Въведете кода в полето за потвърждение по-долу.<br></br>
                    </p>
                    <InputText name='code' id="code" style={{ width: '35%', marginRight: '12px' }} value={data2FA.code} onChange={handle2FAChange} />
                    <Button
                        label="Верифицирай"
                        icon="pi pi-check"
                        severity="success"
                        onClick={submitVerify2FA}
                        raised
                        className='btn-prim-confirm w-100-mob'
                    />

                    {!isInAdmin &&
                        <p className='w-100 text-start mb-0 mt-4'>Можете да смените вида на двуфакторната автентикация от <button className="btn-link" onClick={submitChange2FAMethod}>ТУК</button></p>
                    }
                </>
            }
        </div>
    )
}